<script setup>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { Line } from 'vue-chartjs'
import { defineProps, computed } from "vue";
import { useTheme } from "@/composables/useTheme";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
)

const props = defineProps({
  data: { required: true },
  title: { required: false, default: '' }
});

const { currentTheme } = useTheme()

const options = computed(() => {
  const dark = currentTheme.value === 'dark'
  return {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { top: 10, right: 14, bottom: 6, left: 6 }
    },
    interaction: {
      mode: 'nearest',
      intersect: false,
      axis: 'x'
    },
    scales: {
      x: {
        display: true,
        grid: { display: false },
        border: { display: false },
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 6,
          color: dark ? 'rgba(255,255,255,0.55)' : '#6A6A6A',
          font: { family: 'Montserrat', size: 11, weight: '600' }
        }
      },
      y: {
        display: true,
        grid: {
          color: dark ? 'rgba(255,255,255,0.08)' : 'rgba(15,27,64,0.08)',
          drawBorder: false,
          borderDash: [3, 5]
        },
        border: { display: false, dash: [3, 5] },
        ticks: {
          color: dark ? 'rgba(255,255,255,0.55)' : '#6A6A6A',
          font: { family: 'Montserrat', size: 11, weight: '600' },
          callback: (value) => value + '%'
        },
        min: 0,
        max: 100
      }
    },
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: {
        backgroundColor: '#0F1B40',
        titleColor: '#fff',
        bodyColor: 'rgba(255,255,255,0.8)',
        borderColor: 'rgba(255,255,255,0.1)',
        borderWidth: 1,
        cornerRadius: 10,
        padding: 10,
        displayColors: false,
        titleFont: { family: 'Montserrat', weight: '700' },
        bodyFont: { family: 'Montserrat', weight: '600' },
        callbacks: {
          label: (context) => 'Occupancy: ' + context.parsed.y + '%'
        }
      }
    }
  }
})
</script>

<template>
  <div style="position: relative; height: 100%; width: 100%;">
    <Line :data="props.data" :options="options" />
  </div>
</template>
